import { environment } from "./environments/environment";

// Use shared singleton - check if library already created one, otherwise create and share
let gbInstance: any;

if ((window as any)._gbSharedInstance) {
  gbInstance = (window as any)._gbSharedInstance;
} else {
  gbInstance = new (window as any)["growthbook"].GrowthBook({
    apiHost: environment.growthbookHostApi,
    clientKey: environment.growthbookClientKey,
    enableDevMode: true,
    subscribeToChanges: true,
    attributes: {
      'deployment-region': window.location.hostname.endsWith('.cn') ? 'apa-cn' : 'apa-row'
    },
    trackingCallback: (_experiment: any, _result: any) => {
    },
  });
  gbInstance.loadFeatures();
  // Expose as shared instance for library and debugging
  (window as any)._gbSharedInstance = gbInstance;
}

export let gb = gbInstance;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/growthbook.ts